import { render, staticRenderFns } from "./NewNoticeOrderDahuo.vue?vue&type=template&id=4caed18f&scoped=true&"
import script from "./NewNoticeOrderDahuo.vue?vue&type=script&lang=js&"
export * from "./NewNoticeOrderDahuo.vue?vue&type=script&lang=js&"
import style0 from "./NewNoticeOrderDahuo.vue?vue&type=style&index=0&id=4caed18f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caed18f",
  null
  
)

export default component.exports